<template>
  <el-container>
    <el-aside width="15%">
      <div class="logo">
        <img src="../assets/logo.png" height="100px" width="100px">
      </div>
      <div class="welcome_cn">
        <span>欢迎您</span>
        <el-divider class="divider_01"></el-divider>
        <el-divider class="divider_02"></el-divider>
        <span>Welcome</span>
      </div>
      <el-menu default-active="0" class="el-menu-vertical-demo" @select="selectMenu">
        <el-menu-item index="0">
          <i class="el-icon-document-checked"></i>
          <span slot="title">可接订单</span>
        </el-menu-item>
        <el-menu-item index="4">
          <i class="el-icon-document-checked"></i>
          <span slot="title">支付订单</span>
        </el-menu-item>
        <el-menu-item index="1">
          <i class="el-icon-document-copy"></i>
          <span slot="title">已接订单</span>
        </el-menu-item>
        <el-menu-item index="5">
          <i class="el-icon-s-check"></i>
          <span slot="title">退还订单</span>
        </el-menu-item>
        <el-menu-item index="6">
          <i class="el-icon-document-checked"></i>
          <span slot="title">经典订单</span>
        </el-menu-item>
        <el-menu-item index="2">
          <i class="el-icon-s-check"></i>
          <span slot="title">已出报告</span>
        </el-menu-item>
        <el-menu-item index="3">
          <i class="el-icon-s-data"></i>
          <span slot="title">全部订单</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <div class="phone-tab">
          <span @click="selectMenu(0)">可接接单</span>
          <span @click="selectMenu(4)">支付接单</span>
          <span @click="selectMenu(1)">已接订单</span>
          <span @click="selectMenu(5)">退还订单</span>
          <span @click="selectMenu(6)">经典订单</span>
          <span @click="selectMenu(2)">已出报告</span>
          <span @click="selectMenu(3)">全部订单</span>
        </div>
        <div class="user_info">
          <span class="tip_text">系统到期时间: {{ expirationTime }}</span>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
            <el-avatar shape="square" :src="squareUrl" class="avatar"></el-avatar><span class="user_title">{{getNickname}}</span>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="hospital_info">医院管理</el-dropdown-item>
              <el-dropdown-item command="mod_sign">修改电签</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main>
        <Order :type="orderOfType" />
      </el-main>
      <el-dialog title="修改电签" :visible.sync="modSignVisible">
        <el-upload
          class="upload-demo"
          action="https://yunying.server.storkhealthcare.cn/system/news/uploadImageForNews"
          :before-upload="beforeSignUpload"
          :on-success="getImageUrl"
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
          name="files">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg文件，且不超过500kb</div>
        </el-upload>
        <el-image
          style="width: 100px; height: 100px"
          :src="imageUrl">
        </el-image>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog_cancel">取 消</el-button>
          <el-button type="primary" @click="dialog_confirm">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="医院管理" :visible.sync="hospitalInfoVisible">
        <el-tabs v-model="hospitalCur" @tab-click="handleTabClick">
          <el-tab-pane label="当前医院" name="curhos">
            当前医院：<span>{{ this.storkUserInfo.currentHospitalName }}</span>
            <br>
            <br>
            所有隶属医院：
            <el-select v-model="currentHospitalName" placeholder="请选择" @change="setCurHospital">
              <el-option
                v-for="item in ownHospitals"
                :key="item.hospitalId"
                :label="item.hospitalName"
                :value="item.hospitalId">
              </el-option>
            </el-select>
          </el-tab-pane>
          <el-tab-pane label="医院成员" name="hosemp" v-loading="hosempLoading">
            <div style="height: 300px; overflow-y: scroll">
              <el-table
                :data="hosMemberData"
                style="width: 100%;" v-if="isShowMember">
                <el-table-column
                  prop="account"
                  label="用户账号"
                  width="180">
                </el-table-column>
                <el-table-column
                  label="用户类型">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.idType" placeholder="请选择" @change="changeUserType(scope.row)">
                      <el-option
                        v-for="item in userTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.account != storkUserInfo.username" @click="handleDelete(scope.row)" size="small" type="danger">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-result icon="info" title="信息提示" subTitle="没有权限查看成员列表" v-else>
              </el-result>
            </div>
          </el-tab-pane>
          <el-tab-pane label="添加成员" name="addEmp">
            <div v-if="isShowMember">
              用户账号：
              <el-input v-model="addEmpInfo.account" placeholder="请输入用户账号" clearable maxlength="11" minlength="11"
              style="width: 150px"></el-input>
              <br>
              <br>
              用户类型：
              <el-select v-model="addEmpInfo.userType" placeholder="请用户类型" style="width: 150px">
                <el-option
                  v-for="item in addUserTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <br>
              <br>
              <el-button type="primary" @click="addEmp">添加成员</el-button>
            </div>
            <div v-else>
              <el-result icon="info" title="信息提示" subTitle="没有权限添加成员">
              </el-result>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import { getUserInfo, getExpertInfo, apiGetOwnHospital, modSign, apiSetCurrentHos,
  getCurHospitalMember, delHospitalMember, changeMemberType, addMember} from '../request/api'
import Order from './home/Order'
import resetTime from './utils/JsUtill'

export default {
  name: 'Home',
  components: {Order},
  props: {
    orderType: {
      type: Number,
      default: function () {
        return 0
      }
    }
  },
  data () {
    return {
      nickname: '',
      squareUrl: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      storkUserInfo: {
        nickname: '',
        username: '',
        currentHospitalId: '',
        currentHospitalName: '',
        hospitalList: [],
        expireTime: 0, //到期时间戳
      },
      modSignVisible: false,
      hospitalInfoVisible: false,
      fileList: [],
      imageUrl: '',
      currentHospitalName: '',
      ownHospitals: [],
      hospitalCur: 'curhos',
      hosempLoading: false,
      hosMemberData: [],
      isShowMember: true,
      userTypes: [
        {
          value: 1,
          label: '管理员'
        },
        {
          value: 2,
          label: '专家'
        },
        {
          value: 3,
          label: '技师'
        }
      ],
      addUserTypes: [
        {
          value: 1,
          label: '管理员'
        },
        {
          value: 2,
          label: '专家'
        },
        {
          value: 3,
          label: '技师'
        }
      ],
      addEmpInfo: {
        account: '',
        userType: null
      },
      orderOfType: this.orderType,
      expirationTime: '', //页面展示到期时间
    }
  },
  computed: {
    getNickname () {
      return this.$store.getters.getUser.nickname
    }
  },
  mounted () {
    this.$store.commit('setKeepAlive', ['Home'])
    this.getUserInfo()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'ProduceReport' || to.name === 'EditReport' || to.name === '/') {
      this.$store.commit('setKeepAlive', ['Home'])
    } else {
      this.$store.commit('setKeepAlive', [])
    }
    next()
  },
  methods: {
    selectMenu (index) {
      this.orderOfType = Number(index)
    },
    getIdType (row, column) {
      if (row.idType === 1) {
        return '创建者'
      }
      if (row.idType === 2) {
        return '管理员'
      }
      if (row.idType === 3) {
        return '普通成员'
      }
    },
    // 退出登录
    logout () {
      this.$router.push({'name': 'Logout'})
    },
    // 获取用户信息
    async getUserInfo () {
      let resp = await getUserInfo({
        username: this.$store.getters.getUser.account
      })
      if (resp.code === 1000) {
        let data = resp.data
        this.storkUserInfo = data
        let nowTime = new Date().getTime()
        this.expirationTime = resetTime.methods.getTime(this.storkUserInfo.expireTime) //接口回传过期时间
        let tt = this.storkUserInfo.expireTime - new Date().getTime()
        if(tt <= 7*24*60*60*1000){
          this.$alert('您的使用权限即将到期，请联系管理员充值！','提示',{
          confirmButtonText:'关闭',
          callback:action =>{}
      });
    }
        return 0
      }
      this.$message.error(resp.msg)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`)
    },
    getImageUrl (response, file, fileList) {
      this.imageUrl = file.response.data[0].url
    },
    handleCommand: async function (command) {
      if (command === 'mod_sign') {
        this.modSignVisible = true
        // 请求当前的签名图片
        let resp = await getExpertInfo({
          account: this.$store.getters.getUser.account
        })
        if (resp.code === 1000) {
          this.imageUrl = resp.data.signUrl
        }
        return 0
      }

      if (command === 'hospital_info') {
        this.hospitalInfoVisible = true
        let resp = await apiGetOwnHospital({
          account: this.storkUserInfo.username
        })
        if (resp.code === 1000) {
          this.ownHospitals = resp.data
          this.currentHospitalName = this.storkUserInfo.currentHospitalId
        } else {
          this.$message.error('获取数据失败')
        }
        return 0
      }

      if (command === 'logout') {
        this.$router.push({'name': 'Logout'})
        return 0
      }
    },
    beforeSignUpload (file) {
      const isJpg = file.type === 'image/jpeg'
      const isLt500kb = file.size / 1024 < 500
      if (!isJpg) {
        this.$message.error('上传的图片格式必须是jpg')
      }
      if (!isLt500kb) {
        this.$message.error('上传大小不能超过500kb')
      }
      return isJpg && isLt500kb
    },
    dialog_cancel () {
      this.modSignVisible = false
    },
    hospitalInfo_dialog_cancel () {
      this.hospitalInfoVisible = false
    },
    dialog_confirm () {
      let that = this
      this.$confirm('此操作将永久修改电子签名, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        modSign({
          account: that.$store.getters.getUser.account,
          signUrl: that.imageUrl
        }).then(resp => {
          if (resp.code === 1000) {
            that.$message({
              type: 'success',
              message: '修改成功!'
            })
          } else {
            this.$message({
              type: 'info',
              message: '修改失败'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '修改失败'
        })
      })
      this.modSignVisible = false
    },
    setCurHospital (val) {
      let that = this
      this.$confirm('此操作将修改当前所属医院, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        apiSetCurrentHos({
          account: that.storkUserInfo.username,
          hospitalId: val
        }).then(resp => {
          if (resp.code === 1000) {
            that.$message({
              type: 'success',
              message: '修改成功!'
            })
            that.hospitalInfoVisible = false
            location.reload()
          } else {
            this.$message({
              type: 'info',
              message: '修改失败'
            })
          }
        })
      }).catch(() =>
        this.$message({
          type: 'info',
          message: '修改失败'
        }))
    },
    handleTabClick (val) {
      if (val.name === 'hosemp') {
        this.getCurHospitalMember()
      }
    },
    getCurHospitalMember () {
      this.hosempLoading = true
      let that = this
      getCurHospitalMember({
        account: that.storkUserInfo.username
      }).then((resp) => {
        if (resp.code === 1000) {
          that.hosMemberData = resp.data
          that.isShowMember = true
        } else {
          that.isShowMember = false
        }
        that.hosempLoading = false
      })
    },
    handleDelete (val) {
      let that = this
      this.$confirm('此操作将永久删除该成员的医院信息，是否确定？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delHospitalMember({
          delMemberAccount: val.account,
          creatorAccount: that.storkUserInfo.username,
          hospitalId: val.hospitalId
        }).then((resp) => {
          if (resp.code === 1000) {
            this.$message.success('删除成功')
            // 重新获取当前医院成员
            that.getCurHospitalMember()
          } else {
            this.$message.error(resp.msg)
          }
        })
      }).catch(() => {
      })
    },
    beforeHandleCommand (row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    changeUserType (val) {
      let that = this
      changeMemberType({
        changeMemberAccount: val.account,
        creatorAccount: that.storkUserInfo.username,
        hospitalId: that.storkUserInfo.currentHospitalId,
        type: val.idType
      }).then(resp => {
        if (resp.code === 1000) {
          that.$message.success('用户类型修改成功')
          // 重新获取当前医院成员
          that.getCurHospitalMember()
        } else {
          that.$message.error(resp.msg)
          // 重新获取当前医院成员
          that.getCurHospitalMember()
        }
      })
    },
    addEmp () {
      let hospitalId = this.storkUserInfo.currentHospitalId
      let account = this.addEmpInfo.account
      let idType = this.addEmpInfo.userType
      addMember({
        hospital_id: hospitalId,
        account: account,
        id_type: idType
      }).then(resp => {
        if (resp.code === 1000) {
          this.$message.success('添加成员成功')
        } else {
          this.$message.error(resp.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.el-container {
  height: 100%;
}
.el-aside {
  background-color: #FFFFFF;
  height: 100%;
}
@media (max-width: 900px) {
  .el-aside {
    display: none;
    background-color: #FFFFFF;
    height: 100%;
  }
}
.el-header {
  position: relative;
  background-color: #FFFFFF;
}
.el-main {
  background-color: #FFFFFF;
  margin: 15px;
  border-radius: 5px;
}
@media (max-width: 900px) {
  /deep/ .el-dialog {
    width: 80%;
  }
}
.logo {
  width: 100px;
  height: 100px;
  margin: 10pt auto;
}
.welcome_cn {
  font-size: 11.5pt;
  color: #3381FF;
  font-weight: bold;
  margin-left: 10pt;
  margin-bottom: 15px;
}
.tip_text{
  margin-right: 10px;
}
.divider_01 {
  margin-top: 0;
  margin-bottom: 0;
  height: 5px;
}
.divider_02 {
  margin-top: 5px;
  margin-bottom: 5px;
  height: 3px;
  width: 11.5pt;
  background-color: #3381FF;
  display: inline-block;
}
.phone-tab {
  display: none;
}
@media (max-width: 900px) {
  .phone-tab {
    display: flex;
    width: 60%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
}
.user_info {
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 10px;
  height: 40px;
  margin-right: 15px;
}
.user_title {
  color: #3381FF;
  font-weight: bold;
  font-size: 16px;
  vertical-align: middle;
}
.avatar {
  vertical-align: middle;
  margin-right: 20px;
}
.el-menu {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue